// extracted by mini-css-extract-plugin
export default {"envelope":"AccountNavBarEnvelope_envelope__m3cvQ"};